export default __webpack_public_path__ + "static/media/class.e391572f.md";